import { left, right, Either } from 'fp-ts/lib/Either';
import { csosTokenGenApi } from '.';
import { compose as lcompose } from 'lodash/fp';
import { pathOr } from 'rambda';

export function newUser(code: string): Promise<Either<undefined, string>> {
  return csosTokenGenApi()
    .post(`${import.meta.env.VITE_IDPROOF_API}`, { code })
    .then(get)
    .catch(e => left(void 0));
}

const get = lcompose(
  right,
  pathOr('IDPROOF_API should return a message', 'data.alert')
);
